import { createProfessionalExporter } from '../../utils/professionalExport';
import { formatCurrency } from './receptionistData';

const headers = ['Name', 'Specialization', 'Branch', 'Phone', 'Email', 'Members', 'Status'];

const exporter = createProfessionalExporter({
  title: 'Trainer List',
  headers,
  slug: 'trainers',
  getRows: (list) =>
    list.map((t) => [
      t.name,
      t.specialization,
      t.branch,
      t.phone,
      t.email,
      (t.assignedMembers || []).length,
      t.status === 'active' ? 'Active' : 'Inactive',
    ]),
  getSummary: (list) => [
    `Total trainers: ${list.length}`,
    `Active trainers: ${list.filter((t) => t.status === 'active').length}`,
    `Total payroll: ${formatCurrency(list.reduce((sum, t) => sum + Number(t.salary || 0), 0))}`,
  ],
});

export const printTrainerList = (data) => exporter.print(data);
export const exportTrainerCsv = (data) => exporter.csv(data);
export const exportTrainerExcel = (data) => exporter.excel(data);
export const exportTrainerPdf = (data) => exporter.pdf(data);
export const exportTrainers = (data) => exporter.export(data);
